import React from "react";
import ElfsightWidget from "../../components/ElfsightWidget";

const Blog = () => {
  return (
    <div className="page-blog" id="blogs">
      {/* Page Header */}
      <section className="page-blog__header">
        <div className="container">
          <h1 className="page-blog__title">Blog</h1>
          <p className="page-blog__subtitle">
            After 6+ years of building scalable systems and automating workflows, I've learned a few lessons worth sharing.
          </p>
        </div>
      </section>

      {/* Elfsight Blog Widget with Skeleton Loader */}
      <section className="page-blog__content">
        <div className="container">
          <ElfsightWidget columns={3} rows={2}>
            <div
              className="elfsight-app-4587c51d-6a68-4cd8-813f-2c2f090eee1b"
              data-elfsight-app-lazy
            ></div>
          </ElfsightWidget>
        </div>
      </section>
    </div>
  );
};

export default Blog;
